/****************************************************
 * Module Name:  addHNAModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import HNAProxy from "../../utility/proxy/manager/hnaProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddHNAModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newhna: this.props.editOperation ? this.props.sourceData.name : "",
      newhnafullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newwebref: this.props.editOperation ? this.props.sourceData.webref : "",

      showError: false,

      validateHNAPresentSpinner: false,
      showValidationMessage: false,
      hnaAvailable: true,

      hnaValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newhna,
      fullname: this.state.newhnafullname,
      description: this.state.newdescription,
      webref: this.state.newwebref,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateHNAPresent = (hnaEntered) => {
    if (!hnaEntered || hnaEntered.trim() === "") return;

    this.setState({
      validateHNAPresentSpinner: true,
    });

    HNAProxy.CheckHNAAvailable(hnaEntered, (response) => {
      //if we got response that means hna is present at backend
      if (response) {
        //HNAName already present
        this.setState({
          validateHNAPresentSpinner: false,
          showValidationMessage: true,
          hnaAvailable: false,
        });
      } else {
        //HNAName not available, so can be used
        this.setState({
          validateHNAPresentSpinner: false,
          showValidationMessage: true,
          hnaAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newhnafullname.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.hnaAvailable ||
        this.state.newhnafullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add hna validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit HNA" : "Add New HNA"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>HNA Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        HNA <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newhna}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="HNA (required)"
                          placeholder="Enter HNA"
                          value={this.state.newhna}
                          autoFocus
                          onBlur={(e) =>
                            this.validateHNAPresent(this.state.newhna)
                          }
                          onChange={(e) =>
                            this.setState({
                              newhna: e.target.value,
                              showValidationMessage: false,
                              hnaValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "HNA Cannot be Empty",
                            })
                          }
                          helperText={this.state.hnaValidationError}
                          error={this.state.hnaValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateHNAPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.hnaAvailable ? (
                        <font color="green">HNA available</font>
                      ) : (
                        <font color="red">HNA not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Hna Fullname (required)"
                        placeholder="Enter Hna Fullname"
                        value={this.state.newhnafullname}
                        onChange={(e) =>
                          this.setState({
                            newhnafullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Hna Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Web Reference</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Web Reference"
                        placeholder="Enter Web Reference"
                        value={this.state.newwebref}
                        onChange={(e) =>
                          this.setState({ newwebref: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
